import { gql } from '@apollo/client';

export const GET_PROFESIONALES_PARA_EXCLUIR = gql`
  query getProfesionalesParaExcluir(
    $idTipoProfesional: Int!
    $idDelegacion: Int
    $idClaseMonitoreo: Int
  ) {
    profesionalesParaExcluir(
      idTipoProfesional: $idTipoProfesional
      idDelegacion: $idDelegacion
      idClaseMonitoreo: $idClaseMonitoreo
    ) {
      idProfesional
      nombre
      apellido
      idTipoDocumentoNavigation { descripcion }
      numeroDoc
    }
  }
`;

export const adaptProfesionalExcluir = (p) => ({
  id:            p.idProfesional,
  nombre:        p.nombre,
  apellido:      p.apellido,
  tipoDocumento: p.idTipoDocumentoNavigation?.descripcion ?? '-',
  numeroDoc:     p.numeroDoc ?? '-',
});

export const adaptProfesionalesParaExcluirArray = (data) =>
  structuredClone(data?.profesionalesParaExcluir)?.map(adaptProfesionalExcluir) ?? [];
